import Vue from 'vue';
import {
  alignForNumber,
  addGroupingInResponseData,
  LinkCellRenderer,
  autoResize,
  getPinnedRowData,
  formatNumber
} from '@/helpers/renderHelpers';

import gridProps from '@/gridProps';
import {addColIdToColumns} from "@/helpers/commonHelpers";

export default {
  namespaced: true,
  state: {
    columns: [],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      rowGroupPanelShow: 'always',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle(params) {
          return alignForNumber(params.value);
        },
        valueFormatter(params) {
          return formatNumber(params.value, 2)
        }
      },
      components: {
        'SellerLink': LinkCellRenderer('seller_id', '/partners/'),
        'BuyerLink': LinkCellRenderer('buyer_id', '/partners/'),
        'AgentInvoiceLink': LinkCellRenderer('id', '/sales-agent-invoices/'),
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    gridName: '',
    invoices: [],
    paymentStatuses: [
      {name: 'Not paid', key: 'notpaid'},
      {name: 'Partly paid', key: 'notfullpaid'},
      {name: 'Paid', key: 'paid'}
    ],
    pinnedRowData: [],
    invoicesCount: 0
  },
  getters: {
    gridOptions(state) {
      return {...gridProps, ...state.gridOptions};
    }
  },
  mutations: {
    setInvoices(state, data) {
      if (data.data) {
        state.invoices = addGroupingInResponseData(data.data.results);
        state.columns = addColIdToColumns(data.used_columns);
        state.invoicesCount = data.data.count;
        state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      }
      else {
        state.invoices = data;
        state.pinnedRowData = data;
        state.invoicesCount = 0;
      }
      if (data.grid_name) {
        state.gridName = data.grid_name;
      }
    }
  },
  actions: {
    loadInvoices(store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('accounting/sale_agent_invoices/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setInvoices', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/agents/sales-invoices/salesAgentsInvoices.js